'use client';

// This component initializes i18next on the client side only.
// It must be a 'use client' component to prevent react-i18next from
// running in the Vite SSR module runner, which causes:
//   "createContext is not a function"
// because React is not available in the SSR evaluation context.

import '../../i18n'; // side-effect import: initializes i18next

export function I18nProvider({
    children,
}: {
    children: React.ReactNode;
}) {
    return <>{children}</>;
}
